import React from 'react';
import { getLabel } from '../../../data/labels';
import BetInfo from '../BetInfo';
import EventsList from '../EventsList';
import { getConfiguration } from '../../utils/configuration';
import { getTicketStatusDescription } from '../../utils/getTicketStatusDescription';

function SingleBetTicket(props) {
    let descTicket = getLabel('mybets.singola');
    let ticketStatus = null;
    const conf = getConfiguration();
    if(props.infoTicket || conf.dtsch){
        descTicket = descTicket + " " + (props.ticket.psv? getLabel('retail.protocol.psv') : getLabel('retail.protocol.psqf'));
        ticketStatus = getTicketStatusDescription(props.ticket.status, props.ticket.paidWithCashout);
    }
    return (
        <div className="mybet-container d-flex flex-column">
            <div className="d-flex justify-content-space-between align-items-center margine-su-giu bold pointer details-toggle">
                <span className="text-big bold">{descTicket}</span>
                <span className="margin-auto bold">
                    {props.ticket.funBonus &&
                        <span className="cg-mybet-funbonus">{getLabel('mybets.funbonus')}</span>
                    }
                    {props.ticket.freeBet &&
                        <span className="cg-mybet-funbonus">{getLabel('mybets.freebet')}</span>
                    }
                    {ticketStatus &&
                        <span className="cg-mybet-status-label">{ticketStatus.toUpperCase()}</span>
                    }
                </span>
                <span className="visibility-hidden">{descTicket}</span>
            </div>
            <hr />
            <div className="mybet-events-container" >
                <EventsList isPsv={props.ticket.psv} events={props.ticket.events} />
            </div>
            <div className="light-grey-bg">
                <BetInfo isCheckbet={true} ticket={props.ticket} obfuscateTicketId={props.obfuscateTicketId} />
            </div>
        </div>
    );
}

export default SingleBetTicket;